import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { LangProvider } from "@/i18n/LangContext";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Highlights from "@/components/Highlights";
import Gallery from "@/components/Gallery";
import Amenities from "@/components/Amenities";
import Availability from "@/components/Availability";
import BookingForm from "@/components/BookingForm";
import Loano from "@/components/Loano";
import Reviews from "@/components/Reviews";
import LocationMap from "@/components/LocationMap";
import About from "@/components/About";
import Admin from "@/components/Admin";
import Footer from "@/components/Footer";
import "@/App.css";

function HashScrollHandler() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 100);
      }
    }
  }, [location]);
  return null;
}

function HomePage() {
  const [range, setRange] = useState();
  return (
    <>
      <Hero />
      <Highlights />
      <Gallery />
      <Amenities />
      <Availability range={range} setRange={setRange} />
      <BookingForm range={range} setRange={setRange} />
      <Loano />
      <Reviews />
      <LocationMap />
    </>
  );
}

function PublicLayout({ children }) {
  return (
    <div className="App" data-testid="amac-site">
      <Header />
      <HashScrollHandler />
      <main>{children}</main>
      <Footer />
    </div>
  );
}

function Layout() {
  return (
    <>
      <Routes>
        <Route path="/admin" element={<Admin />} />
        <Route
          path="/"
          element={
            <PublicLayout>
              <HomePage />
            </PublicLayout>
          }
        />
        <Route
          path="/about"
          element={
            <PublicLayout>
              <About />
            </PublicLayout>
          }
        />
        <Route
          path="*"
          element={
            <PublicLayout>
              <HomePage />
            </PublicLayout>
          }
        />
      </Routes>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#1A3B4D",
            color: "#FAF9F6",
            border: "1px solid #102632",
            fontFamily: "Outfit, sans-serif",
          },
        }}
      />
    </>
  );
}

function App() {
  return (
    <LangProvider>
      <BrowserRouter>
        <Layout />
      </BrowserRouter>
    </LangProvider>
  );
}

export default App;
